<script>
    import Navbar from './navbar.svelte'
    import PhoneInfo from './phone-info.svelte'
    import NavbarIcons from './navbaricons.svelte'
    import RoundieCircles from './roundie-circles.svelte';
    import RoundieIcons from './roundie-icons.svelte';
    import CardLabel from './cardlabel.svelte'
    import CardLabelText from './cardlabel-text.svelte'
    import BottomButtonBar from '../shared/bottom-button-bar.svelte'

    export let theme
    export let primary
    export let tertiary
    export let homeRoundiesColor

    const staticAssetPrefix = (window.fanxVersion && window.fanxVersion.urlPrefix) || '/'

    $: backgroundImage = `${staticAssetPrefix}img/onboarding/${
        theme === true ? 'home-background-dark.png' : 'home-background.png'
    }`
</script>

<style>
    .fno-preview {
        width: 414px;
        height: 896px;
        position: relative;
        margin-bottom: 25px;
    }
</style>

<div class="fno-preview" style="background-image: url({backgroundImage});">
    <Navbar fill={primary} />
    <PhoneInfo />
    <NavbarIcons />
    <RoundieCircles fill={homeRoundiesColor} />
    <RoundieIcons />
    <CardLabel fill={tertiary} />
    <CardLabelText />
    <BottomButtonBar fill={primary} />
</div>
